/**
 * Application Routes
 *
 * This file serves as a wrapper around both backend (Rails) and frontend routes.
 * It provides a consistent interface for accessing all routes in the application.
 *
 * Example usage:
 * - Routes.backend.authPath('google')  // Backend route to Google OAuth
 * - Routes.frontend.dashboardPath()    // Frontend route to the dashboard
 */

import * as BackendRoutes from './api/routes';

// Backend routes are generated by ts_routes-rails
const backend = {
  ...BackendRoutes,
};

// Frontend routes are defined manually here to match the SPA routing
const frontend = {
  rootPath: '/',
  loginPath: '/login',
  registerPath: '/register',
  confirmPath: '/confirm',
  appPath: '/app',
  mcpsPath: '/mcps',
  mcpPath: (id: string) => `/mcps/${id}`,
  mcpViewPath: (id: string) => `/mcps/${id}/view`,
  mcpCreatePath: '/mcps/create',
  mcpEditPath: (id: string) => `/mcps/${id}/edit`,
  mcpRulesPath: (id: string) => `/mcps/${id}/rules`,
  rulesPath: '/rules',
  rulePath: (id: string) => `/rules/${id}`,
  ruleCreatePath: '/rules/create',
  ruleEditPath: (id: string) => `/rules/${id}/edit`,
  communityRulesPath: '/community-rules',
} as const;

// Combine both types of routes into a single export
export const Routes = {
  backend,
  frontend,
};

export default Routes;
